import HTTP from '../lib/http'

const ARTICLE_HOST = 'https://baleen2-prod.bieyangapp.com/v1/articles/_search'

export function searchRelatedArticles(f = 0, t = 20, q: string) {
  return HTTP.get(
    `${ARTICLE_HOST}?f=${f}&t=${t}&q=${q}`
  )
}
